/* with love from shopstory */
Object.defineProperty(exports, '__esModule', { value: true });

function isCompiledComponentConfig(arg) {
  return typeof arg === "object" && arg !== null && typeof arg._template === "string" && typeof arg._id === "string" && typeof arg.actions === "object" && typeof arg.components === "object";
}

function isRenderableContent(input) {
  return typeof input === "object" && input !== null && "renderableContent" in input && (isCompiledComponentConfig(input.renderableContent) || input.renderableContent === null);
}

function isNonEmptyRenderableContent(input) {
  return typeof input === "object" && input !== null && "renderableContent" in input && isCompiledComponentConfig(input.renderableContent);
}

function isEmptyRenderableContent(input) {
  return typeof input === "object" && input !== null && "renderableContent" in input && input.renderableContent === null;
}

exports.isEmptyRenderableContent = isEmptyRenderableContent;
exports.isNonEmptyRenderableContent = isNonEmptyRenderableContent;
exports.isRenderableContent = isRenderableContent;
